import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

// AccountSettings interface
export interface IAccountSettings {
  legalName: string;
  businessType: string;
  gstNumber: string;
  billingAddress: string;
  businessCategory: string;
  currency: string;
}

// AccountInfo interface
export interface IAccountInfo {
  accountName: string;
  accountStatus: 'Active' | 'Inactive' | 'Suspended' | 'Pending';
  accountOwner: string;
  accountSettings: IAccountSettings;
  contactEmail: string;
  contactWhatsApp: string;
}

@Component({
  selector: 'app-account-info',
  imports: [
    CommonModule,
    FormsModule,
    CardModule,
    ButtonModule,
    InputTextModule
  ],
  templateUrl: './account-info.html',
  styleUrl: './account-info.css'
})
export class AccountInfo implements OnInit {
  public accountInfo: IAccountInfo = {
    accountName: 'SimplyGenie Technologies',
    accountStatus: 'Active',
    accountOwner: 'Raveendar',
    accountSettings: {
      legalName: 'SimplyGenie Technologies Private Limited',
      businessType: 'Private Limited Company',
      gstNumber: '29ABCDE1234F1Z5',
      billingAddress: '123 Tech Park, Bangalore, Karnataka - 560001, India',
      businessCategory: 'Software Development',
      currency: 'INR',
    },
    contactEmail: 'accounts@simplygenie.com',
    contactWhatsApp: '+91 98765 43210'
  };

  isEditing = false;
  originalData: IAccountInfo = { ...this.accountInfo };

  // Dropdown options
  businessTypeOptions = [
    { label: 'Private Limited Company', value: 'Private Limited Company' },
    { label: 'Public Limited Company', value: 'Public Limited Company' },
    { label: 'Partnership', value: 'Partnership' },
    { label: 'Sole Proprietorship', value: 'Sole Proprietorship' },
    { label: 'LLP (Limited Liability Partnership)', value: 'LLP (Limited Liability Partnership)' },
    { label: 'Trust', value: 'Trust' }
  ];

  businessCategoryOptions = [
    { label: 'Software Development', value: 'Software Development' },
    { label: 'IT Services', value: 'IT Services' },
    { label: 'Consulting', value: 'Consulting' },
    { label: 'E-commerce', value: 'E-commerce' },
    { label: 'Healthcare', value: 'Healthcare' },
    { label: 'Education', value: 'Education' },
    { label: 'Finance', value: 'Finance' },
    { label: 'Manufacturing', value: 'Manufacturing' },
    { label: 'Other', value: 'Other' }
  ];

  currencyOptions = [
    { label: 'Indian Rupee (INR)', value: 'INR' },
    { label: 'US Dollar (USD)', value: 'USD' },
    { label: 'Euro (EUR)', value: 'EUR' },
    { label: 'British Pound (GBP)', value: 'GBP' },
    { label: 'Australian Dollar (AUD)', value: 'AUD' },
    { label: 'Canadian Dollar (CAD)', value: 'CAD' }
  ];

  accountStatusOptions = [
    { label: 'Active', value: 'Active', color: 'green' },
    { label: 'Inactive', value: 'Inactive', color: 'gray' },
    { label: 'Suspended', value: 'Suspended', color: 'red' },
    { label: 'Pending', value: 'Pending', color: 'yellow' }
  ];

  ngOnInit() {
    // Initialize component
  }

  toggleEdit() {
    this.isEditing = !this.isEditing;
    if (!this.isEditing) {
      // Reset to original data if canceling
      this.accountInfo = { ...this.originalData };
    }
  }

  saveAccountInfo() {
    // Save account info logic here
    console.log('Saving account info:', this.accountInfo);
    this.originalData = { ...this.accountInfo };
    this.isEditing = false;
  }

  getStatusColor(status: string): string {
    const statusOption = this.accountStatusOptions.find(option => option.value === status);
    return statusOption?.color || 'gray';
  }

  getStatusBadgeClass(status: string): string {
    const color = this.getStatusColor(status);
    switch (color) {
      case 'green': return 'bg-green-100 text-green-800';
      case 'red': return 'bg-red-100 text-red-800';
      case 'yellow': return 'bg-yellow-100 text-yellow-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  }
}